import { Component, OnDestroy, OnInit, } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SidenavService } from "src/app/layout/sidenav/sidenav.service";
import { ApiService } from "src/app/services/api.service";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import endpoints from "src/app/helpers/endpoints";
import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { fadeInRightAnimation } from "src/@fury/animations/fade-in-right.animation";
import { fadeInUpAnimation } from "src/@fury/animations/fade-in-up.animation";
import { scaleInAnimation } from "src/@fury/animations/scale-in.animation";
import { CommonService } from "src/app/services/common.service";
import { ErrorType } from "src/app/enums/error-type.enum";
import { AgreementActionsService } from "../../services/agreement-actions.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { ChargeManuallyModalComponent } from "../modals/charge-manually-modal/charge-manually-modal.component";
import { ManageOptionalItemModalComponent } from "../modals/manage-optional-item-modal/manage-optional-item-modal.component";
import { CancelAgreementModalComponent } from "../modals/cancel-agreement-modal/cancel-agreement-modal.component";
import { UpgradeDowngradeAgreementModalComponent } from "../modals/upgrade-downgrade-agreement-modal/upgrade-downgrade-agreement-modal.component";
import { CoverItemDetailsModalComponent } from "../modals/cover-item-details-modal/cover-item-details-modal.component";
import { EventService } from "src/app/services/event.service";
import { TransferAgreementComponent } from "../modals/transfer-agreement/transfer-agreement.component";
import { checkoutAddress, UserData } from "src/app/models/user-data.models";
import { RenewAgreementComponent } from "../modals/renew-agreement/renew-agreement.component";
import { CustomerDashboardService } from "../../services/customer-dashboard.service";
import { ContentActionComponent } from "src/app/shared/content-action/content-action.component";
import { Confirmation } from "src/app/enums/confirmation.enum";
enum SectionsNameEnum {
  ContactInformation = "updateContactInfo",
  AgreementHolder = "updateAgreementHolderDetail",
  SendOrderConfirmationMail ="sendOrderConfirmationMail",
  ServiceAgreementMail = "serviceAgreementMail",
}

@Component({
  selector: "fury-view-agreement",
  templateUrl: "./view-agreement.component.html",
  styleUrls: ["./view-agreement.component.scss"],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class ViewAgreementComponent implements OnInit, OnDestroy {
  userId = "";
  agreementId = "";
  agreementDetails: any;
  financialStats: any;
  isLoading = false;
  fetchUser  = false;
  kpiData: any = null;
  editingTab = null;
  allSections = SectionsNameEnum;
  ngUnsubscribe = new Subject<void>();
  claimDetails: any;
  isDenied = true;
  editorAccess:boolean = false;
  contactInfoForm = new FormGroup<any>({
    firstName: new FormControl("", [Validators.required]),
    lastName: new FormControl("", [Validators.required]),
    phoneNumber: new FormControl("", [Validators.required]),
    emailAddress: new FormControl("", [
      Validators.required,
      Validators.pattern(/^[\w.-]+@[\w.-]+\.\w{2,3}$/),
    ]),
  });

  agreementHolderForm = new FormGroup<any>({
    firstName: new FormControl("", [Validators.required]),
    lastName: new FormControl("", [Validators.required]),
    phoneNumber: new FormControl("", [Validators.required]),
    emailAddress: new FormControl("", [
      Validators.required,
      Validators.pattern(/^[\w.-]+@[\w.-]+\.\w{2,3}$/),
    ]),
  });

  agreementHolderModalForm = new FormGroup<any>({
    firstName: new FormControl("", [Validators.required]),
    lastName: new FormControl("", [Validators.required]),
    phoneNumber: new FormControl("", [Validators.required]),
    emailAddress: new FormControl("", [
      Validators.required,
      Validators.pattern(/^[\w.-]+@[\w.-]+\.\w{2,3}$/),
    ]),
  });
  constructor(
    private sidenavService: SidenavService,
    private router: Router,
    private activateRoute: ActivatedRoute,
    private apiService: ApiService,
    public commonService: CommonService,
    private agreementActionService: AgreementActionsService,
    private dialog: MatDialog,
    private eventService: EventService,
    private customerDashboardService: CustomerDashboardService
  ) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.sidenavService.close();
    }, 0);
    this.userId = this.activateRoute.snapshot.params["id"];
    this.agreementId = this.activateRoute.snapshot.params["agreementId"];
    if (this.agreementId) {
      this.getAgreementViewDetails();
      this.getAgreementKpi();
      this.getAgreementFinancialStats();
    }
    this.agreementActionService.shouldViewFetchAgreement$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: boolean) => {
        if (res) this.getAgreementViewDetails();
      });
      this.agreementActionService.shouldFetchAgreementKPI$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: boolean) => {
        if (res) this.getAgreementKpi();
      });
      this.eventService.userData.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: UserData)=>{
        this.editorAccess = res.editorAccess;
       })
  }

  redirectToDashboard() {
    this.router.navigateByUrl(`customer-dashboard/${this.userId}`);
  }
  getAgreementViewDetails() {
    this.isLoading = true;
    this.apiService
      .get(
        endpoints.customerDashboard.getAgreementViewDetails(this.agreementId)
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          this.isLoading = false;
          if (res.body) {
            this.agreementDetails = res.body?.agreement;
            this.isDenied = res.body?.agreement?.isDenied;
            this.setFormValues();
          }
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.error?.message, ErrorType.Error);
          this.isLoading = false;
        },
      });
  }

  getAgreementFinancialStats() {
    this.apiService
    .get(endpoints.customerDashboard.getAgreementFinancialStats(this.agreementId))
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe({
      next: (res: HttpResponse<any>) => {
        if (res?.body) {
          this.financialStats = res.body?.financialStats;
        }
      },
      error: (err: HttpErrorResponse) => {
        this.apiService.alert(err.error?.message, ErrorType.Error);
        this.isLoading = false;
      },
    });
  }

  getAgreementKpi() {
    this.apiService
      .get(endpoints.customerDashboard.getAgreementKpi(this.agreementId))
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res?.body) {
            this.kpiData = res.body;
          }
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.error?.message, ErrorType.Error);
          this.isLoading = false;
        },
      });
  }

  setFormValues() {
    this.patchContactInfoForm();
    this.patchAgreementHolderForm();
  }

  editSection(section) {
    this.setFormValues();
    this.editingTab = section;
  }

  cancelSection() {
    this.editingTab = null;
    this.setFormValues();
  }

  saveSection(section: string) {
    switch (section) {
      case this.allSections.ContactInformation: {
        this.submitContactInformation();
        break;
      }

      case this.allSections.AgreementHolder: {
        this.submitAgreementHolder();
        break;
      }
    }
  }

  submitContactInformation() {
    if (this.contactInfoForm.invalid) {
      this.contactInfoForm.markAllAsTouched();
      return;
    }
    this.editingTab = null;
    const payload = {
      contactInformation: {
        firstName: this.contactInfoForm.get("firstName").value,
        lastName: this.contactInfoForm.get("lastName").value,
        phoneNumber: this.contactInfoForm.get("phoneNumber").value,
        emailAddress: this.contactInfoForm.get("emailAddress").value,
      },
    };
    this.updateAgreement(this.allSections.ContactInformation, payload);
  }

  submitAgreementHolder() {
    if (this.agreementHolderForm.invalid) {
      this.agreementHolderForm.markAllAsTouched();
      return;
    }
    this.editingTab = null;
    const payload = {
      firstName: this.agreementHolderForm.get("firstName").value,
      lastName: this.agreementHolderForm.get("lastName").value,
      phoneNumber: this.agreementHolderForm.get("phoneNumber").value,
      emailAddress: this.agreementHolderForm.get("emailAddress").value,
    };
    this.updateAgreement(this.allSections.AgreementHolder, payload, true);
  }

  updateAgreement(section, payload, skipRefetch = false) {
    this.apiService
      .post(
        endpoints.customerDashboard.updateAgreement(this.agreementId, section),
        payload
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          this.apiService.alert(
            res?.body?.message,
            ErrorType.Success
          );
          if(!skipRefetch){
            this.getAgreementViewDetails();
          }
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(
            err.error?.message || err?.message,
            ErrorType.Error
          );
        },
      });
  }

  patchContactInfoForm() {
    this.contactInfoForm.setValue({
      firstName: this.agreementDetails?.contactInfo?.firstName || null,
      lastName: this.agreementDetails?.contactInfo?.lastName || null,
      phoneNumber: this.agreementDetails?.contactInfo?.phoneNumber || null,
      emailAddress: this.agreementDetails?.contactInfo?.emailAddress || null,
    });
  }

  patchAgreementHolderForm() {
    this.agreementHolderForm.setValue({
      firstName: this.agreementDetails?.firstName || null,
      lastName: this.agreementDetails?.lastName || null,
      phoneNumber: this.agreementDetails?.phoneNumber || null,
      emailAddress: this.agreementDetails?.emailAddress || null,
    });
  }

  formatCurrency(priceValue) {
    if (!priceValue) return "";
    return `$${Number(priceValue)?.toFixed(2)}`;
  }
  getWaitingPeriod(days) {
    if (!days) return "";
    if (Number(days) === 1) return `${days} day`;
    return `${days} days`;
  }
  openActionModal(modalName: string) {
    this.agreementActionService.openActionModal(this.agreementId, modalName);
  }
  handleAddSpecialRequest() {
    if (!this.agreementDetails?.agreementNumber && !this.userId) return;

    this.customerDashboardService.handleSpecialRequest(this.userId, null, false,null,this.agreementDetails?.agreementNumber);
  }
  handleAddNotes() {
    if (!this.agreementDetails?.agreementNumber && !this.userId) return;
    this.customerDashboardService.handleAddNotes(this.userId, null, false, this.agreementDetails?.agreementNumber, null);
  }
  handleAddFeedback() {
    if (!this.agreementDetails?.agreementNumber && !this.userId) return;
    this.customerDashboardService.handleFeedbackRequest(this.userId, null, false, null, this.agreementDetails?.agreementNumber);
  }

  sendOrderConfirmation(){
    this.updateAgreement(this.allSections.SendOrderConfirmationMail, {});
  }


  sendServiceAgreementMail(){
    this.updateAgreement(this.allSections.ServiceAgreementMail, {});
  }
  handleFileClaimWithAgreement() {
    if (!this.agreementDetails?.agreementNumber && !this.userId) return;
    this.router.navigateByUrl(
      `customer-dashboard/${this.userId}/file-a-claim?agreementNumber=${this.agreementDetails?.agreementNumber}`
    );
  }
  handleChargeManually() {
    this.dialog
      .open(ChargeManuallyModalComponent, {
        width: "600px",
        panelClass: "payment-info",
        data: this.userId,
      })
      .afterClosed()
      .subscribe((res: any) => {
        if (res) return;
      });
  }
  handleOptionalItem() {
    this.dialog
    .open(ManageOptionalItemModalComponent, {
      width: "600px",
      panelClass: "payment-info",
      data: {agreementId: this.agreementId, userId: this.userId}
    })
    .afterClosed()
    .subscribe((res: any) => {
      if(res) return;
    });
  }
  handleCancelAgreement() {
    this.dialog
      .open(CancelAgreementModalComponent, {
        width: "600px",
        panelClass: "payment-info",
        data: {agreementId: this.agreementId,  isShowSaveForLaterButton : true},
      })
      .afterClosed()
      .subscribe((res: any) => {
        this.customerDashboardService.setFetchLabel(false);
        if (res) {
          this.getAgreementViewDetails();
          this.getAgreementKpi();
          this.getAgreementFinancialStats();
          this.customerDashboardService.setFetchLabel(true);
          this.fetchUser = true;
        }
      });
  }
  handleUpgradeOrDowngradeAgreement(calculationType: string) {
    this.dialog
      .open(UpgradeDowngradeAgreementModalComponent, {
        width: "800px",
        panelClass: "payment-info",
        data: {agreementId: this.agreementId, calculationType, userId: this.userId },
      })
      .afterClosed()
      .subscribe((res: any) => {
        if (res) this.getAgreementViewDetails();
      });
  }
  transferAgreement(){
    this.dialog
      .open(TransferAgreementComponent, {
        width: "800px",
        panelClass: "payment-info",
        data: this.agreementId
      })
      .afterClosed()
      .subscribe((res: any) => {
        if (res) this.getAgreementViewDetails();
      });
  }
  openCoveredItemDetailsModal(itemInfo: any){
    if (!(window as any).matchMedia("(min-width: 991px)").matches) {
      this.dialog.open(CoverItemDetailsModalComponent, {
       autoFocus: false,
       maxWidth: '100vw',
       height: '100vh',
       panelClass: 'quotecomponent',
       data: { item: itemInfo }
     });
   } else {
      this.dialog.open(CoverItemDetailsModalComponent, {
       autoFocus: false,
       width: '900px',
       data: { item: itemInfo }
     });
   }
  }

  handleRenewAgreement(calculationType: string) {
    this.dialog
      .open(RenewAgreementComponent, {
        width: "800px",
        panelClass: "payment-info",
        data: {agreementId: this.agreementId, calculationType, userId: this.userId },
      })
      .afterClosed()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: any) => {
        if (res) this.getAgreementViewDetails();
      });
    }
  handleCheckout() {
    const checkoutData = {
      firstName: this.agreementDetails?.firstName,
      lastName: this.agreementDetails?.lastName,
      email: this.agreementDetails?.emailAddress?.toLowerCase(),
      phone: this.agreementDetails?.phoneNumber,
      address: this.agreementDetails?.coveredAddress?.streetAddress?.split(',')[0],
      city: this.agreementDetails?.coveredAddress?.city,
      state: this.agreementDetails?.coveredAddress?.state,
      zip: this.agreementDetails?.coveredAddress?.zip,
      unitNumber: this.agreementDetails?.coveredAddress?.unitNumber,
      planTypeId: this.agreementDetails?.orderPlanDetail?.orderPropertyTypeId,
      planSizeId: this.agreementDetails?.orderPlanDetail?.orderPropertySizeId,
      planPriceId: this.agreementDetails?.orderPlanDetail?.orderMainPlanId,
      leadId: this.agreementDetails?.leadId,
      paymentMethod : this.agreementDetails?.paymentMethod

    }
    this.eventService.checkoutAddress.next(checkoutData);

    this.router.navigateByUrl(`customer-dashboard/${this.userId}/checkout?coverageInfo=true&ai=${this.agreementId}`);
  }
   handleRenew() {
    const checkoutData: checkoutAddress = {
      firstName: this.agreementDetails?.firstName,
      lastName: this.agreementDetails?.lastName,
      email: this.agreementDetails?.emailAddress?.toLowerCase(),
      phone: this.agreementDetails?.phoneNumber,
      address: this.agreementDetails?.coveredAddress?.streetAddress?.split(',')[0],
      city: this.agreementDetails?.coveredAddress?.city,
      state: this.agreementDetails?.coveredAddress?.state,
      zip: this.agreementDetails?.coveredAddress?.zip,
      unitNumber: this.agreementDetails?.coveredAddress?.unitNumber,
      planTypeId: this.agreementDetails?.orderPlanDetail?.orderPropertyTypeId,
      planSizeId: this.agreementDetails?.orderPlanDetail?.orderPropertySizeId,
      planPriceId: this.agreementDetails?.orderPlanDetail?.orderMainPlanId,
      leadId: this.agreementDetails?.leadId,
      paymentMethod : this.agreementDetails?.paymentMethod,
      freeMonth: this.agreementDetails?.freeMonth,
      pricingOption: this.agreementDetails?.pricingOption,
      copayFee: this.agreementDetails?.copayFee,
    }
    this.eventService.checkoutAddress.next(checkoutData);

     this.router.navigateByUrl(`customer-dashboard/${this.userId}/checkout?coverageInfo=true&ai=${this.agreementId}&renewAgreement=true`);
  }
  getServiceAgreementPdf() {
    this.apiService
      .get(
        `${endpoints.customerServiceAgreement.getAgreementPdf(this.agreementId, 1)}`
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          const pdfUrl = res.body?.serviceAgreementPdf;
          if (pdfUrl) {
            fetch(pdfUrl)
              .then((response) => response.blob())
              .then((blob) => {
                const blobUrl = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = blobUrl;
                link.download = "Service_Agreement.pdf";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(blobUrl);
              });
          } else {
            this.apiService.alert("Service Agreement Not Found", ErrorType.Error);
          }
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.message, ErrorType.Error);
        },
      });
  }
  changeAgreementStatus() {
    this.dialog
      .open(ContentActionComponent, {
        data: { type: "changeAgreementStatus" },
      })
      .afterClosed()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: Confirmation) => {
        if (res === Confirmation.Yes) {
          this.customerDashboardService.setFetchLabel(false);
          this.apiService
            .patch(
              endpoints.customerDashboard.changeAgreementStatus(
                this.agreementId
              )
            )
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
              next: (res: HttpResponse<any>) => {
                if (res.body) {
                  this.apiService.alert(res.body?.message, ErrorType.Success);
                  this.customerDashboardService.setFetchLabel(true);
                  this.getAgreementViewDetails();
                  this.getAgreementKpi();
                }
              },
              error: (err: HttpErrorResponse) => {
                this.apiService.alert(err.message, ErrorType.Error);
              }
            });
        }
      });
  }
 getEscrowInvoice() {
  this.apiService
    .get(endpoints.customerDashboard.getEscrowInvoice(this.agreementId))
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe({
      next: (res: HttpResponse<any>) => {
        const pdfUrl = res.body?.escrowInvoicePdf;
        if (pdfUrl) {
          fetch(pdfUrl)
            .then(response => response.blob())
            .then(blob => {
              const blobUrl = window.URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = blobUrl;
              link.download = 'Escrow_Invoice.pdf';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(blobUrl);
            });
        } else {
          this.apiService.alert('Escrow Invoice Not Found', ErrorType.Error);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.apiService.alert(err.error, ErrorType.Error);
      },
    });
}

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
